import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AddVideoImageForRedundRequestComponent } from '../add-video-image-for-redund-request/add-video-image-for-redund-request.component';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-refund-request-preview',
  templateUrl: './refund-request-preview.component.html',
  styleUrls: ['./refund-request-preview.component.scss'],
})
export class RefundRequestPreviewComponent {
  showModal = true;

  orderData: any;
  displayFields: any[] = [];
  shippingFields: any[] = [];
  billingFields: any[] = [];
  isFullscreen = false;
  fullscreenSrc = '';
  fullscreenType: 'image' | 'video' | null = null;
  isSubmitting: any;
  newCommentText: string;
  login_user_details: any;
  commentData: any;
  productName: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RefundRequestPreviewComponent>,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public cookieService: CookieService,
    private apiservice: ApiservicesService,
    public matSnackBar: MatSnackBar
  ) {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('login_user_details===>', this.login_user_details);
  }

  ngOnInit(): void {
    this.orderData = this.data?.value;

    console.log('Order Data:', this.orderData);
    const comments = this.orderData.returnComment;
    const CommentData = this.orderData.returnComment;
    this.productName = this.data?.commentList?.[0]?.products?.[0]?.name;
    console.log('productName=====>', this.productName);

    if (Array.isArray(comments)) {
      comments.sort((a, b) => a.createdAt - b.createdAt);
      this.commentData = comments;
    }

    console.log('Comments to display:', this.commentData);

    console.log('commentData:===========>', CommentData);
  }

  openFullscreen(event: Event, type: 'image' | 'video', media: any) {
    console.log(
      'Media Check-------->>',
      `https://${media.bucket}.s3.amazonaws.com/${media.baseurl}${media.fileservername}`
    );

    event.stopPropagation();
    this.fullscreenType = type;
    if (type === 'image') {
      this.fullscreenSrc = `https://${media.bucket}.s3.amazonaws.com/${media.baseurl}${media.fileservername}`;
    } else {
      this.fullscreenSrc = `https://${media.bucket}.s3.amazonaws.com/${media.baseurl}/${media.fileservername}`;
    }

    this.isFullscreen = true;
  }

  addComment(): void {
    if (this.isSubmitting) return;
    const text = (this.newCommentText || '').trim();
    if (!text) return;
    this.isSubmitting = true;

    const requestObject = this.orderData.returnComment?.[0];
    const userType = this.login_user_details.userinfo.user_type;
    console.log('userType=====>', userType);

    if (!requestObject) {
      console.error('Error: Could not find the request data to add a comment.');
      this.isSubmitting = false;
      return;
    }

    const payload = {
      user_id: this.orderData.user_id,

      return_request_id: this.orderData._id,

      comment_text: text,
      user_type: userType,

      is_private_note: false,
    };

    const apiUrl = '/refund-processing/return-request-comment-add';
    this.apiservice.getHttpDataPost(apiUrl, payload).subscribe({
      next: (response: any) => {
        this.commentData.push(response.results);
        this.newCommentText = '';
        this.isSubmitting = false;
        console.log('Comment added successfully!', response);

        // <<< START: Activity Tracker Integration >>>
        const actorName =
          this.login_user_details?.userinfo?.name ||
          this.login_user_details?.userinfo?.firstname +
            (this.login_user_details?.userinfo?.lastname
              ? ' ' + this.login_user_details.userinfo.lastname
              : '') ||
          'User';

        interface ActivityPayload {
          user_id: any;
          refundRequestId: any;
          type: string;
          description: string;
          actor: {
            userId: any;
            role: any;
            name: any;
            email: any;
          };
          metadata?: {
            Comment?: string;
          };
        }

        const activityPayload: ActivityPayload = {
          user_id: requestObject.user_id,
          refundRequestId: this.orderData._id,
          type: 'COMMENT_ADDED',
          description: `${text}`,
          actor: {
            userId: this.login_user_details?.userinfo?._id,
            role: this.login_user_details?.userinfo?.user_type,
            name: actorName,
            email: this.login_user_details?.userinfo?.email || '',
          },
          metadata: {
            Comment: `${actorName} added a comment (${
              (this.login_user_details?.userinfo?.user_type || 'is_admin') ===
              'is_admin'
                ? 'Admin'
                : ''
            }) "${text}"`,
          },
        };

        this.apiservice
          .getHttpDataPost(
            'refund-activity/refund-activity-add',
            activityPayload
          )
          .subscribe({
            next: () => {
              console.log('Activity for comment addition logged successfully.');
            },
            error: (err) => {
              console.error(
                'Failed to log activity for comment addition:',
                err
              );
            },
          });
      },
      error: (err) => {
        console.error('Failed to add comment:', err);
        this.isSubmitting = false;
      },
    });
  }

  closeFullscreen() {
    this.isFullscreen = false;
    this.fullscreenSrc = '';
    this.fullscreenType = null;
  }

  addimageButtonClick() {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(AddVideoImageForRedundRequestComponent, {
      panelClass: 'custom-modalbox',
      data: {
        image_only: true,
        return_request_id: this.orderData._id,
      },
    });
  }
  addvideoButtonClick() {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(AddVideoImageForRedundRequestComponent, {
      panelClass: 'custom-modalbox',
      data: {
        video_only: true,
        return_request_id: this.orderData._id,
      },
    });
  }

  closePopup() {
    this.dialogRef.close();
  }
}
